export default {
      id: "ic_hide-usage",
      viewBox: "0 0 24 22",
      url: "/" + "images/icons.3.109.2.svg#ic_hide-usage",
      toString: function () {
        return this.url;
      }
    }